/**
 * Common Constants & Configuration
 * Reusable constants and configurations used across the application
 */

// Candidate Table Columns Configuration
export const CANDIDATE_TABLE_COLUMNS = [
  { label: "Sr No", key: "srNo", isSortable: false },
  { label: "", key: "actions", isAction: true }, // Changed to empty for icon
  { label: "Name", key: "name" },
  // { label: "Resume", key: "resumeFile" }, // COMMENTED OUT - Resume column disabled
  { label: "Status", key: "feedbackStatus" },
  { label: "Role", key: "role" },
  { label: "Exp", key: "experience" }, // Changed to "Exp"
  { label: "Primary\nSkills", key: "primarySkills" }, // Multiline
  { label: "Secondary Skills", key: "secondarySkills" },
  { label: "Tech Stack", key: "techStack" },
  { label: "Available\nFrom", key: "availableFrom" }, // Multiline
  { label: "Remote", key: "remoteAvailable" },
  { label: "Work Type", key: "workType" },
  { label: "CTC", key: "c2c" },
  { label: "Expected\nCTC", key: "expectedCTC" }, // Multiline
  { label: "Freelance\nRate", key: "freelanceRate" }, // Multiline
  { label: "Referrer\nCode", key: "referrerCode" }, // Multiline
  { label: "Source", key: "source" },
  { label: "Email", key: "email" },
  { label: "Phone", key: "phone" },
  { label: "Location", key: "location" },
//   { label: "Applied Date", key: "appliedDate" },
  { label: "Travel", key: "readyToTravel" } // Changed to "Travel"
  // { label: "Aadhar No", key: "aadharNo" }, // COMMENTED OUT - Aadhar No column disabled
  // { label: "Pan Card No", key: "pancardNo" } // COMMENTED OUT - Pan Card No column disabled
];

// Jobs Table Columns Configuration
export const JOBS_TABLE_COLUMNS = [
  { label: "SrNo", key: "srNo", isSortable: false, width: "50px" },
  { label: "✏️", key: "actions", isAction: true, width: "40px" }, // Decreased by 0.5 times, header shows edit icon
  { label: "Job ID", key: "job_id", width: "60px" },
  { label: "Title", key: "title", width: "200px" },
  { label: "Status", key: "status", width: "50px" },
  { label: "Skills", key: "skill", width: "250px" }, // Increased by 1.5 times
  { label: "Exp", key: "experience_required", width: "50px" },
  { label: "Type", key: "job_type", width: "60px" },
  { label: "Department", key: "department", width: "120px" },
  { label: "Description", key: "job_description", width: "700px", minWidth: "600px" }, // Increased by 4 times
  { label: "Company", key: "company", width: "140px" },
  { label: "Created By", key: "created_by", width: "120px" },
  { label: "Remote", key: "remote_work", width: "70px" },
  { label: "Location", key: "location", width: "120px" },
  { label: "Budget", key: "budget", width: "70px" },
  { label: "Posted", key: "posted_on", width: "70px" },
  { label: "Closing", key: "closing_on", width: "70px" }
];

export const APPLIED_JOBS_TABLE_COLUMNS = [
  { label: "SrNo", key: "srNo", width: "50px", className: "srno-column" },
  { label: "🔔", key: "notice", width: "60px", className: "notice-column" },
  { label: "Job ID", key: "job_id", width: "40px", className: "id-column" },
  { label: "Title", key: "job_title", width: "200px", className: "job-title-column", isClickable: true },
  { label: "Company", key: "job_company", width: "90px", className: "company-column" },
  { label: "Location", key: "job_location", width: "100px", className: "location-column" },
  { label: "Type", key: "job_type", width: "50px", className: "job-type-column" },
  { label: "Remote", key: "remote_work", width: "65px", className: "remote-column" },
  { label: "Budget", key: "budget", width: "50px", className: "budget-column" },
  { label: "Exp", key: "experience_required", width: "40px", className: "experience-column" },
  { label: "Status", key: "status", width: "60px", className: "status-column" },
  { label: "Applied On", key: "applied_on", width: "70px", className: "applied-on-column" }
];

export const FEEDBACK_TABLE_COLUMNS = [
  { label: "SrNo", key: "srNo", width: "50px", className: "srno-column" },
  { label: "Status", key: "status", width: "80px", className: "status-column", isSortable: true },
  { label: "Comment", key: "comment", width: "400px", className: "comment-column" },
  { label: "Created By", key: "createdBy", width: "80px", className: "createdby-column", isSortable: true },
  { label: "Created Date", key: "createdDate", width: "95px", className: "createddate-column", isSortable: true }
];

// Default Fallback Roles
export const DEFAULT_FALLBACK_ROLES = [
  { role_id: 3, role_name: 'RECRUITER' },
  { role_id: 2, role_name: 'HR' },
  { role_id: 1, role_name: 'ADMIN' }
];

// Filter Initial State
export const INITIAL_CANDIDATE_FILTERS = {
  name: "",
  role: "",
  location: "",
  skills: "",
  experience: "",
  workType: "",
  feedbackStatus: "",
  readyToTravel: "",
  remoteAvailable: "",
  source: "",
  // noticePeriod: "", // COMMENTED OUT - Notice period filter disabled
  availableFromStart: "",
  availableFromEnd: ""
};

// Pagination Settings
export const PAGINATION_SETTINGS = {
  DEFAULT_ITEMS_PER_PAGE: 10,
  AVAILABLE_ITEMS_PER_PAGE: [5, 10, 15, 20, 50],
  MAX_PAGES_TO_SHOW: 5
};

// Experience Range
export const EXPERIENCE_RANGE = {
  MIN: 0,
  MAX: 30
};
